
define('eteration/ui/ko-validation',['jquery',
        'knockout',
        'eteration/eteration-i18n',
        'eteration/ui/validation-helper',
        'moment',
        'underscore'], 
	function($,ko,i18n,validationHelper, moment, underscore) {
	
    var _selector = "*[data-validation]";
    
    var focusBinded = false;

    function _submitFocus(form, isScrollEnabledOnFocus) {
    	var isModal = form.find('.modal.in').length > 0;
    	form = isModal ? form.find('.modal.in') : form.find('form');
    	
    	var focusRow = form.find('.has-error:visible, .has-warning:visible').first().closest('.tk-input-field') ||
    		form.find('.has-error:visible, .has-warning:visible').first();
    	if(focusRow.length) {
	    	if(isModal) {
	    		if(!window.isIOS && isScrollEnabledOnFocus) {
	    			scrollToEl(focusRow);
	    		}
	    	} else if(!window.isIOS || isScrollEnabledOnFocus) {
	    		scrollToEl(focusRow);
	    	}
    	}
    }
    

    ko.jqValidation = function (config) {
    	
        return new function () {
            var self = this;
            
            $.extend(self, config);
            
            var validators=validationHelper.validators;
            
            self.containerElement = null;
            
            self.Validate = function (id, isScrollEnabledOnFocus) {
            	
                if (!self.containerElement){
                	throw new Error("Validate called, but container element has not been set yet.");
                }

                var elements = self.containerElement.find(_selector);
                var errors = [];
                var validationResult = {"valid" : true};

                for (var i = 0; i < elements.length; i++) {
					var el = elements[i];
					var dv = $(el).data('validation');
					var customControl = dv["checkCustom"] || false;
					var validationProperties = self.validationProperties ? ko.unwrap(self.validationProperties) : [];
					var validationProperty = self.validationPropertyResolver ? self.validationPropertyResolver(validationProperties, dv.validationId) : {};
					
					dv.required = underscore.isBoolean(validationProperty.required) ?  validationProperty.required : dv.required;
					
					var required = underscore.isBoolean(dv.required) ? dv.required : false;
					var error = undefined;
					
					if(required){
						 error = validators["required"](el);
						 if(error && dv.requiredMsg){
							 error = dv.requiredMsg;
						 }
					}

					if(!error){	
						var validator = dv.validator;
						if(!validators["required"](el) &&  validator){
							error = validators[validator](el,dv);
						}
					}

					if(!error && (required || customControl)) {
						var cv = dv.custom; 
						if(cv){
							error = self.customValidators[cv](el);
						}
					}
					
					var validationTriggers = $(el).attr('data-validation-triggers') || "";
					var triggeredByOtherComponent = $.inArray(id,validationTriggers.split(','))>=0;
					var triggeredBySelf = id && id === el.id;
					var triggeredByAnonymous = !id;
					
					if((triggeredByOtherComponent || triggeredBySelf || triggeredByAnonymous) && error){
						errors.push({'id':el.id,'el':el,'error':error});						
					}else {
						if(triggeredBySelf || triggeredByOtherComponent){
							validationHelper.removeError(el);
						}
						if ((triggeredBySelf || triggeredByOtherComponent) && !required && $.trim($(el).val())) {
							validationHelper.showValidationSuccesIcon(el);
						} else if(!error){
							validationHelper.removeError(el);
						}
					}
				}
                
                if(!id && errors.length == 0 && self.postValidators){
	                for(var k = 0 ; k < self.postValidators.length ;k++){
	                	var postValidator = self.postValidators[k];
	                	var ele = $("#"+postValidator.id)[0];
	                	if(ele){
		                	var errorMsg = postValidator.func();
		                	if(errorMsg) {
		                		errors.push({'id':postValidator.id,'el':ele,'error':errorMsg});
		                	} else if(!errorMsg){ 
		                		validationHelper.removeError(ele);
		                	}
	                	}
	                }
                }

				if (errors.length) {
					validationHelper.showClientErrors(errors);
					validationResult.errors = errors;
					validationResult.valid = false;

					if (!focusBinded) {
						var form = $(self.containerElement).closest('form');
						if (form.length) {
							_submitFocus(form, isScrollEnabledOnFocus);
							var button = form.find('button[type="submit"]');
							if (button.length) {
								focusBinded = true;
								button.off('.valitadion')
								button.on('click.valitadion', function() {
									_submitFocus(form, isScrollEnabledOnFocus);
								})
							}
						} else if(!$(self.containerElement).parent().is('#signupForm')) {
							_submitFocus($(self.containerElement).parent(), isScrollEnabledOnFocus);
						}
					}
				}
                return validationResult;
                
            };
        };
    };
    
   
    ko.bindingHandlers.jqValidation = {
    		
        update: function (element, valueAccessor) {
            var $element = $(element); 
            var validationCtx = valueAccessor();
            var inputSelector = 'input,textarea,select';
            validationCtx.containerElement = $element;
            
			var validateEvent = valueAccessor().validateEvent ? valueAccessor().validateEvent : "change";// change event was the default event for jq validation. Now with this line, we can change the validate event however we want.

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                validationCtx.containerElement = null;
            });
            
            var executeValidation = function(event){
            	var dataValidation = $('#'+event.currentTarget.id).attr('data-validation');
            	var isScrollEnabledOnFocus = dataValidation && (typeof JSON.parse(dataValidation).disableonfocusvalidate != 'undefined') && !JSON.parse(dataValidation).disableonfocusvalidate;
				setTimeout(function () {
					var targetId = event.currentTarget.id || event.currentTarget.dataset.vId;
					validationCtx.Validate(targetId, isScrollEnabledOnFocus)
				}, 1000);
            }

			$element.find(inputSelector).each(function (_, el) {
				el.dataset.value = el.value;
			});

			$element.on('focusout', inputSelector, executeValidation);

			$element.on(validateEvent, inputSelector, function (e) {
				if (e.target.dataset.value !== e.target.value) {
					e.target.dataset.value = e.target.value;
					executeValidation(e);
				}
			});
        
        }
    };
});
